import Post from 'app/utils/Post';

export default class Patch extends Post {
    method = 'PATCH';
}
